import { api } from '@shared/config/axiosConfig';
import { buildEndpoint } from '@shared/utils/buildEndpoint';
import {
  calculationCreateToDto,
  calculationFromDto,
  calculationUpdateToDto,
} from '@/features/agreements/mappers/calculationsMapper';
import { validateRequiredFields } from '@/shared/utils/validateRequiredFields';

const BASE_ENDPOINT = 'agreements';

const buildServiceEndpoint = ({ agreementId, calculationId } = {}) => {
  return buildEndpoint(BASE_ENDPOINT, { id: agreementId }, [
    'calculations',
    calculationId,
  ].filter(Boolean));
};

export const createCalculation = async (agreementId, data) => {
  validateRequiredFields({ agreementId });

  const payload = calculationCreateToDto(data);
  const endpoint = buildServiceEndpoint({ agreementId });
  const response = await api.post(endpoint, payload);
  return calculationFromDto(response.data);
};

export const updateCalculation = async (agreementId, calculationId, data) => {
  validateRequiredFields({ agreementId, calculationId });

  const payload = calculationUpdateToDto(data);
  const endpoint = buildServiceEndpoint({ agreementId, calculationId });
  const response = await api.put(endpoint, payload);
  return calculationFromDto(response.data);
};
